import * as yup from 'yup';
import { UserFireRequest } from '@/shared/state/api/swagger';

export const deleteUserSchema = yup.object<Pick<UserFireRequest, 'date_of_dismissal'>>({
	date_of_dismissal: yup.string().required({ message: 'Поле обязательно для заполнения' }),
});
